import clsx from 'clsx';
import React, { type ComponentPropsWithoutRef } from 'react';
import { BASE_PATH } from '@/constants/constants';
import './ControlButton.scss';

type Variants = 'primary' | 'secondary' | 'tertiary';
export interface ControlButtonProps extends ComponentPropsWithoutRef<'button'> {
	ariaLabel?: string;
	className?: string;
	disabled?: boolean;
	icon?: string;
	iconPosition?: 'left' | 'none' | 'right';
	iconSize?: string;
	label?: string;
	onClick?: (e: React.SyntheticEvent) => void;
	rounded?: boolean;
	variant?: Variants;
}

export const ControlButton = ({
	ariaLabel,
	className,
	disabled,
	icon,
	iconPosition = 'left',
	iconSize = '1em',
	label,
	onClick,
	rounded,
	variant = 'primary',
	...rest
}: ControlButtonProps) => {
	const hasValidIcon = icon && icon !== 'none' && iconPosition !== 'none';
	const buttonAttributes = {
		onClick,
		'data-variant': variant,
		...(disabled && { disabled: true }),
		...(ariaLabel && { 'aria-label': ariaLabel }),
		...(hasValidIcon && { 'data-icon-alignment': iconPosition }),
		...(rounded && { 'data-border-rounded': true })
	};

	return (
		<button type="button" className={clsx('control-button', className)} {...buttonAttributes} {...rest}>
			{label && <span className="[ control-button__label ] [ text-button-base ]">{label}</span>}
			{hasValidIcon && (
				<svg className="[ control-button__icon icon ]" width={iconSize} height={iconSize} fill="currentColor">
					<use xlinkHref={`${BASE_PATH}/speedboat/icons/toyota-icons.svg#${icon}`} />
				</svg>
			)}
		</button>
	);
};
